module.exports = __webpack_public_path__ + "img/AUT.c255e284.svg";